import { render, staticRenderFns } from "./WordListContainer.vue?vue&type=template&id=a3b64fc2&"
import script from "./WordListContainer.vue?vue&type=script&lang=js&"
export * from "./WordListContainer.vue?vue&type=script&lang=js&"
import style0 from "./WordListContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports